import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
            用户评价
          </h2>
          <p className="text-sm text-foreground-600">听听每日大赛入口的用户怎么说</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.slice(0, 3).map((comment) => (
            <div
              key={comment.id}
              className="rounded-xl bg-background-100 p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 mt-3 text-xs text-foreground-500">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-thumb-up-line"></i>
                </span>
                {comment.likes}
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {comments.slice(3, 5).map((comment) => (
            <div
              key={comment.id}
              className="rounded-xl bg-background-100 p-5 md:p-6 flex"
            >
              <img
                src={comment.avatar}
                alt={comment.name}
                className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                loading="lazy"
              />
              <div className="ml-3 flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {comment.content}
                </p>
                <div className="flex items-center gap-1 mt-2 text-xs text-foreground-500">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-thumb-up-line"></i>
                  </span>
                  {comment.likes}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}